export class Auth {
  store = null;
  router = null;

  isLogged() {
    return this.store ? this.store.auth.isLogged : false;
  }
}

const instance = new Auth();

async function authHelper(Vue, options) {
  if (options.router) {
    const router = options.router;

    await router.beforeEach(async (to, from, next) => {
      const result = !!options.store.state.userInfo.apikey || (await options.store.dispatch('trySilentLogin'));
      const logged = options.store.getters.isLogged || result;

      if (logged && options.store.getters.expiredPassword && to.name !== 'ForcePasswordChange') {
        router.push({ name: 'ForcePasswordChange' }).catch(() => null);
        return;
      }

      try {
        if (logged) {
          if (to.fullPath.includes('register') || to.fullPath.includes('login')) return next({ name: 'home' });
          return next();
        } else {
          if (to.name.includes('home')) return next({ name: 'landing' });
          if (to.meta.middleware) return next({ name: 'login' });
          return next();
        }
      } catch (error) {
        console.dir(error);
        return next({ name: 'login' });
      }
    });
  }

  Object.defineProperties(Vue.config.globalProperties, {
    $auth: {
      get() {
        return instance;
      },
    },
  });
}

export default authHelper;
